export const PUBLIC_PATHS = {
    LOGIN: "/login",
  };
  
  export const PROTECTED_PATHS = {
    DASHBOARD: "/dashboard",
  };

  export const VERIFY_PATHS = {
    VERIFY: "/verify",
  }

  export const FORGOTPASSWORD_PATHS = {
    VERIFY: "/forgotpassword",
  }